export const confirmCreateCaseMessage =
  "Please confirm you would like to create a case in Case Manager.";

export const confirmDismissMessage =
  "Please confirm that you want to dismiss this subject.";
